import {
    REQUEST_CLIENT_LIST,
    REQUEST_ADD_CLIENT,
    REQUEST_EDIT_CLIENT,
    REQUEST_SINGLE_CLIENT,
    SET_SINGLE_CLIENT
} from "@actions/actionTypes";

export function getClientsList(page, limit, nameLike="", sortDirDesc="") {
    return dispatch => {
        dispatch({
            type: REQUEST_CLIENT_LIST,
            limit,
            page,
            nameLike,
            sortDirDesc
        });
    }
}

export function getSingleClient(id) {
    return dispatch => {
        dispatch({
            type: REQUEST_SINGLE_CLIENT,
            id
        });
    }
}

export function removeSingleClient() {
    return dispatch => {
        dispatch({
            type: SET_SINGLE_CLIENT,
            client: {}
        });
    }
}

export function addClient(body) {
    return dispatch => {
        dispatch({
            type: REQUEST_ADD_CLIENT,
           body
        });
    }
}

export function editClient(body) {
    return dispatch => {
        dispatch({
            type: REQUEST_EDIT_CLIENT,
            body
        });
    }
}
